module.exports = __webpack_public_path__ + "static/media/microphone-stand.b4a561a8.svg";